module.exports = __webpack_public_path__ + "static/Spring-Onion-Dip-d4e6b20e769e11a80a093471491bec2e.png";